import React, { useState } from 'react';
import {
  Box, Button, Input, VStack, Heading, useToast, Text
} from '@chakra-ui/react';
import { useAuthCliente } from '../context/AuthClienteContext';
import { signOut } from 'firebase/auth';
import { auth } from '../firebase/firebase-config';
import { useNavigate } from 'react-router-dom';
import Lottie from 'lottie-react';
import SplashAnimation from '../assets/splash.json';

export default function RegistroPage() {
  const { signup } = useAuthCliente();
  const toast = useToast();
  const navigate = useNavigate();

  const [form, setForm] = useState({
    firstName: '',
    lastName: '',
    email: '',
    password: '',
    invitationToken: ''
  });

  const [loadingSignup, setLoadingSignup] = useState(false);

  const handleSignupChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSignup = async () => {
    setLoadingSignup(true);
    try {
      console.log('[Registro] Datos enviados:', form);
      const { userCredential, companyId } = await signup(
        form.email,
        form.password,
        form.firstName,
        form.lastName,
        form.invitationToken
      );

      toast({
        title: 'Cuenta creada exitosamente',
        description: 'Ya podés iniciar sesión con tu correo y contraseña.',
        status: 'success',
        duration: 4000,
        isClosable: true,
        position: 'top'
      });

      setTimeout(() => {
        signOut(auth);
        navigate('/login');
      }, 3000);

    } catch (err) {
      console.error('[Registro] Error al crear cuenta:', err);
      toast({
        title: 'Error al crear cuenta',
        description: err.message || 'Ocurrió un error durante el registro.',
        status: 'error',
        duration: 5000,
        isClosable: true,
        position: 'top'
      });
    } finally {
      setLoadingSignup(false);
    }
  };

  return (
    <Box minH="100vh" display="flex" alignItems="center" justifyContent="center" bg="2" px={4} pt={60} position="relative">
     <Box position="absolute" top="10%" left="32%" zIndex={0}>
  <Lottie animationData={SplashAnimation} loop autoplay style={{ width: '35vw', height: '35vh' }} />
</Box>

      <VStack spacing={6} w="full" maxW="md" bg="white" p={6} borderRadius="md" boxShadow="lg" zIndex={1}>
        <Heading size="lg" textAlign="center">Crear Cuenta</Heading>

        <VStack spacing={3} w="full">
          <Input
            name="firstName"
            placeholder="Nombre"
            value={form.firstName}
            onChange={handleSignupChange}
          />
          <Input
            name="lastName"
            placeholder="Apellido"
            value={form.lastName}
            onChange={handleSignupChange}
          />
          <Input
            name="email"
            placeholder="Correo electrónico"
            type="email"
            value={form.email}
            onChange={handleSignupChange}
          />
          <Input
            name="password"
            placeholder="Contraseña"
            type="password"
            value={form.password}
            onChange={handleSignupChange}
          />
          <Input
            name="invitationToken"
            placeholder="Token de invitación"
            value={form.invitationToken}
            onChange={handleSignupChange}
          />
          <Button
            colorScheme="blue"
            w="full"
            onClick={handleSignup}
            isLoading={loadingSignup}
            loadingText="Creando cuenta..."
          >
            Crear Cuenta
          </Button>
        </VStack>

        <Text fontSize="sm" color="gray.500">
          ¿Ya tenés cuenta? <b><a href="/login">Iniciá sesión aquí</a></b>
        </Text>
      </VStack>
    </Box>
  );
}